const EMBED_RESOURCE_TYPE_NAME = "embedV2";

export { EMBED_RESOURCE_TYPE_NAME };
//# sourceMappingURL=contants.js.map
